module.exports = __webpack_public_path__ + "static/media/LV1@3x.fd9139c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/LV/LV1@3x.png
// module id = 672
// module chunks = 0